import { createApp } from 'vue';
import { createPinia } from 'pinia';
import { initAuth } from '@gigdriver/client';
import { initFirestore } from '@gigdriver/client';
import { initFunctions } from '@gigdriver/client';
import vuetify from './plugins/vuetify';
import router from './router';
import App from './App.vue';
import { useAuthStore } from './stores/auth';

// Initialize Firebase services
initAuth();
initFirestore();
initFunctions();

const app = createApp(App);
const pinia = createPinia();

app.use(pinia);
app.use(router);
app.use(vuetify);

// Initialize auth state before mounting
const authStore = useAuthStore(pinia);
authStore.initAuth().then(() => {
  app.mount('#app');
});
